<div class="container container-responsive">
  <h1 class="title" translate>My exports</h1>
  <h3 translate>Here you will find all the exported recordings</h3>
  <app-composition-exports (navigate)="go($event)"></app-composition-exports>
</div>
